import {
  offset as offsetMiddleware,
  shift as shiftMiddleware,
  flip as flipMiddleware,
  autoPlacement as autoPlacementMiddleware,
  size as sizeMiddleware,
  Middleware,
} from '@floating-ui/react';
import { useMemo } from 'react';
import { IUseDropDownMiddlewaresOptions } from './use-drop-down-middlewares.types';

export const useDropDownMiddlewares = ({
  isOverToggler,
  middlewares,
  offset = 0,
  shouldAutoPlacement,
  shouldFlip,
  shouldShift = true,
  useParentWidth = true,
  shiftPadding,
}: IUseDropDownMiddlewaresOptions = {}) => useMemo(() => {
  const finalMiddlewares: Middleware[] = [];

  finalMiddlewares.push(
    offsetMiddleware(({ rects }) => {
      return isOverToggler ? -rects.reference.height : offset;
    }),
  );

  if (middlewares) {
    finalMiddlewares.push(...middlewares);
  }

  if (shouldShift) {
    finalMiddlewares.push(shiftMiddleware({
      crossAxis: true,
      altBoundary: true,
      padding: shiftPadding
    }));
  }

  if (shouldFlip) {
    finalMiddlewares.push(flipMiddleware());
  }

  if (shouldAutoPlacement) {
    finalMiddlewares.push(autoPlacementMiddleware());
  }

  if (useParentWidth) {
    finalMiddlewares.push(
      sizeMiddleware({
        apply({ rects, elements }) {
          Object.assign(elements.floating.style, {
            width: `${rects.reference.width}px`,
          });
        },
      }),
    );
  }

  return finalMiddlewares;
}, [isOverToggler, middlewares, offset, shiftPadding, shouldAutoPlacement, shouldFlip, shouldShift, useParentWidth]);
